// Client-Side Schema spiegelt das Master-DTO (CreateAgentRequest).
// Master ist die Source-of-Truth — bei Validation-Drift erkennt der User es per
// 400-Response inline im Dialog. Schema hier ist UX-Optimierung (Live-Feedback).

export interface CreateAgentInput {
  id: string;
  name: string;
  description: string;
  type: "user-agent" | "service-agent";
  ownerId: string | null;
  cwd?: string;
  // #196: undefined = Default ("Standard"-Profil falls vorhanden), null = bewusst
  // keins (leere Config), string = explizit gewähltes Profil.
  profileId?: string | null;
}

const ID_REGEX = /^[a-z0-9][a-z0-9._-]*$/;

export interface ValidationError {
  field: keyof CreateAgentInput;
  message: string;
}

export function validateCreateAgent(input: CreateAgentInput): ValidationError[] {
  const errors: ValidationError[] = [];

  if (input.id.length === 0) {
    errors.push({ field: "id", message: "Pflichtfeld" });
  } else if (input.id.length > 64) {
    errors.push({ field: "id", message: "max 64 Zeichen" });
  } else if (!ID_REGEX.test(input.id)) {
    errors.push({ field: "id", message: "nur a-z 0-9 . _ - (start mit a-z/0-9)" });
  }

  if (input.name.length === 0) {
    errors.push({ field: "name", message: "Pflichtfeld" });
  }
  if (input.description.length === 0) {
    errors.push({ field: "description", message: "Pflichtfeld" });
  }
  if (input.type !== "user-agent" && input.type !== "service-agent") {
    errors.push({ field: "type", message: "user-agent oder service-agent" });
  }

  return errors;
}
